export const theme = {
  colors: {
    empty: "#e9edf6",
    background: "#FFFFFF",
    primary: "#000000",
    textButtonColor: "#515458",
    primaryTextColor: "#26282B",
    secondaryTextColor: "#828A9D",
    activeTextColor: "#004FEC",
    disabledTextColor: "#8D9CB0",
    cardBackground: "#FFFFFF",
    cardPurpleBackground: "#f0eaff",
    cardOrangeBackground: "#fff2e2",
    cardPurpleText: "#7a57c9",
    cardOrangeText: "#f19825",
    cardBorder: "#F0F1F2",
    dividerColor: "#000000",
    inputLabel: "#515458",
    inputBorder: "#E1E6ED",
    inputActive: "#003fbd",
    active: "#003fbd",
    disabled: "#F0F3F9",
    error: "#da2e2e",
    danger: "#da2e2e",
    success: "#004fec",
    cancel: "#F43E3E",
    primary100: "#003FBD",
    primary50: "#004FEC",
    gray100: "#26282B",
    gray90: "#3C3F44",
    gray80: "#515458",
    gray50: "#70747D",
    gray40: "#838791",
    gray20: "#9A9EA8",
    gray10: "#D4D9E3",
    gray5: "#F0F3F9",
    line30: "#E1E6ED",
    line20: "#F2F2F4",
    bluegray100: "#092349",
    bluegray40: "#949DB2",
    white: "#FFFFFF",
    disable: "#8D9CB0",
  },
};
